import React, { useEffect, useState } from 'react';
import { observer } from 'mobx-react';
import buyMoreEnterpriceDiscussionImg from 'Assets/png/buy-more-enterprice-discussion.png';
import profileState from 'Stores/profile';
import { Utils } from 'Utils/utils';
import Button from 'Components/common/Button';
import * as CONSTANTS from 'Utils/constants';
import './buyMoreCredits.scss';
import { paygPurchaseMorePopupState } from 'Components/common/paygPurchaseMorePopup';

const { MX_PAYG_PRICING_EVENT } = CONSTANTS;

const BuyMoreCredits = observer(() => {
  const {
    extraCreditsPaymentDetailLoading,
    CURRENT_STEPS,
  } = paygPurchaseMorePopupState;
  const { CVV_SCREEN, FAILED_SCREEN } = CURRENT_STEPS;

  const [buyNowLoadingMap, setBuyNowLoadingMap] = useState([]);
  const [
    enterpriseInterestApiLoading,
    setEnterpriseInterestApiLoading,
  ] = useState(false);

  const updateLoaderInfo = (planId, value) => {
    const temp = Utils.copyObjectWithoutReference(buyNowLoadingMap);
    temp[planId] = value;
    setBuyNowLoadingMap(temp);
  };

  const handleContactUsClick = () => {
    setEnterpriseInterestApiLoading(true);
    if (!enterpriseInterestApiLoading) {
      Utils.mixpanelTrack(
        MX_PAYG_PRICING_EVENT.LB_PAYG_BUY_MORE_ENTERPRISE_CLICKED,
        {},
      );
      const callback = () => {
        setEnterpriseInterestApiLoading(false);
      };
      Utils.enterprisePlanInterestNotification('CUSTOM_PRICING', callback);
    }
  };

  const handleBuyNowClick = async planDetails => {
    try {
      if (!extraCreditsPaymentDetailLoading) {
        const {
          id: planId,
          price,
          lbCredits,
          pricePerCredit,
          phoneCredits,
        } = planDetails;
        Utils.mixpanelTrack(MX_PAYG_PRICING_EVENT.LB_PAYG_BUY_NOW_CLICKED, {
          planId,
          price,
          lbCredits,
          pricePerCredit,
        });
        updateLoaderInfo(planId, true);
        const response = await paygPurchaseMorePopupState.getExtraCreditsPaymentDetail(
          lbCredits,
          phoneCredits,
        );

        updateLoaderInfo(planId, false);
        paygPurchaseMorePopupState.setPopupValues({
          numberOfCreditsRequired: lbCredits,
          amount: price,
          callback: () => {},
          isBuyMoreCreditsPage: true,
        });
        if (response) paygPurchaseMorePopupState.setShowPopup(CVV_SCREEN);
        else paygPurchaseMorePopupState.setShowPopup(FAILED_SCREEN);
      }
    } catch (e) {
      console.log('get card details', e);
    }
  };

  useEffect(() => {
    profileState.getBuyMoreCreditsPlans();
  }, []);

  useEffect(() => {
    const idMap = {};
    // eslint-disable-next-line array-callback-return
    profileState.moreCreditsPlanDetails.map(item => {
      const { id } = item;
      idMap[id] = false;
    });

    setBuyNowLoadingMap(idMap);
  }, [profileState.moreCreditsPlanDetails]);

  return (
    <div className="buy-more-credits-page">
      <div className="recharge-credits-title">Recharge Credits</div>
      <div className="plan-details-wrapper">
        <div className="title">Choose the plan that fits your needs</div>
        <div className="plan-list-wrapper">
          {profileState.isMoreCreditsPlanLoading
            ? Array.from({ length: 3 }).map((item, index) => {
                return (
                  <div
                    key={`more-credits-${index}`}
                    className="plan-item-wrapper placeholder"
                  >
                    <div className="price-detail linear-background" />
                    <div className="credits-detail linear-background" />
                    <div className="action-btn linear-background" />
                    <div className="credit-validity-notes linear-background" />
                  </div>
                );
              })
            : profileState.moreCreditsPlanDetails.map(planDetails => {
                const {
                  id,
                  price,
                  lbCredits,
                  phoneCredits,
                  savingPrice = null,
                } = planDetails;

                return (
                  <div className="plan-item-wrapper" key={id}>
                    {savingPrice !== null && (
                      <div className="saving-price-info">
                        Save ${Utils.viewsDownloadsNumberFormat(savingPrice)}
                      </div>
                    )}
                    <div className="price-detail">
                      ${Utils.viewsDownloadsNumberFormat(price)}
                    </div>
                    <div className="credits-detail">
                      {Utils.viewsDownloadsNumberFormat(lbCredits)}{' '}
                      <span>email</span>
                      credits
                    </div>
                    <div className="credits-detail">
                      {Utils.viewsDownloadsNumberFormat(phoneCredits)}{' '}
                      <span>phone</span>
                      credits
                    </div>
                    <Button
                      btnText="Buy Now"
                      icon={false}
                      iconName=""
                      type="button"
                      className={`action-btn${
                        buyNowLoadingMap[id] ? ' loading' : ''
                      }`}
                      loader={buyNowLoadingMap[id]}
                      click={() => handleBuyNowClick(planDetails)}
                    />
                    <div className="credit-validity-notes">
                      Credits are valid till your current subscription lasts
                    </div>
                  </div>
                );
              })}
        </div>
        <div className="enterprise-plan-discuss-wrapper">
          {/* <div className="background-gradient" /> */}
          <div className="discuss-wrapper background-gradient">
            <img
              src={buyMoreEnterpriceDiscussionImg}
              alt="buyMoreEnterpriceDiscussionImg"
            />
            <div className="description-wrapper">
              <div className="desc-title">
                Power up your prospecting with Adapt Enterprise.
              </div>
              <div className="desc-content">
                Need more credits, dedicated support, or more features? We are
                there to help you out.
              </div>
            </div>

            <div className="action-btn">
              <Button
                btnText="Contact us"
                icon={false}
                iconName=""
                type="button"
                className={`action-btn ${
                  enterpriseInterestApiLoading ? ' loading' : ''
                }`}
                loader={enterpriseInterestApiLoading}
                click={() => handleContactUsClick()}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
});

export default BuyMoreCredits;
